
import './reviewsIndicators.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import menuLayout from '../../directive/menu-layout';
import starRating from '../../directive/star-rating';
import doughnutTextInside from '../../directive/doughnut-text-inside';
import configurableChart from '../../directive/configurable-chart';

import reviewsIndicators from '../../service/reviewsIndicators';
import user from '../../service/user';
import brand from '../../service/brand';

import pickerFilter from '../../filter/picker';

import routing from './reviewsIndicators.routes';
import ReviewsIndicatorsController from './reviewsIndicators.controller';

export default angular.module('page.reviewsIndicators', [
		uirouter,
		menuLayout,
		starRating,
		doughnutTextInside,
		configurableChart,
		reviewsIndicators,
		brand,
		user,
		pickerFilter,
		'chart.js'
	])
	.config(routing)
	.controller('ReviewsIndicatorsController', ReviewsIndicatorsController)
	.name;



// WEBPACK FOOTER //
// ./src/page/reviewsIndicators/index.js